module.exports = __webpack_public_path__ + "img/38_48.7c54482b.png";